// DEV-431 Navigation optimisation.

// #6: mobile drawer accordions keep only one product group open per panel.
(() => {
    if (window.vigoNavAccordion) return;
    window.vigoNavAccordion = true;

    document.addEventListener('click', (event) => {
        const header = event.target.closest('.mobile-accordion-item > .mobile-accordion-header');
        if (!header) return;

        const item = header.parentElement;
        const willOpen = !item.classList.contains('active');
        const scroller = item.closest('.menu-dropdown');
        const topBefore = header.getBoundingClientRect().top;

        // Close the other group at once so the tapped header stays under the finger.
        item.parentElement.querySelectorAll(':scope > .mobile-accordion-item.active').forEach((openItem) => {
            if (openItem === item) return;
            openItem.classList.add('is-instant');
            openItem.classList.remove('active');
            openItem.querySelector('.mobile-accordion-header').setAttribute('aria-expanded', 'false');
            openItem.offsetHeight;
            openItem.classList.remove('is-instant');
        });
        if (scroller) scroller.scrollTop += header.getBoundingClientRect().top - topBefore;

        item.classList.toggle('active', willOpen);
        header.setAttribute('aria-expanded', String(willOpen));
    });
})();

// #10: the menu help card opens the LiveChat widget (#chat-widget-container),
// waiting up to 10s if the widget script hasn't loaded yet.
document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-nav-help-chat]')) return;
    let attempts = 0;
    const openChat = () => {
        if (window.LiveChatWidget) {
            window.LiveChatWidget.call('maximize');
        } else if (attempts++ < 50) {
            setTimeout(openChat, 200);
        }
    };
    openChat();
});

// #3: the shared predictive-search component keeps its results open after the query is cleared;
// in the menu drawer they would cover the categories, so hide them once the field is empty.
(() => {
    const hideIfEmpty = (event) => {
        const search = event.target.closest('predictive-search.nav-search');
        if (!search) return;
        setTimeout(() => {
            if (!search.querySelector('input[type="search"]').value.trim()) search.removeAttribute('open');
        });
    };
    document.addEventListener('reset', hideIfEmpty, true);
    document.addEventListener('input', hideIfEmpty, true);
})();

// #4: before typing, searches marked [data-nav-suggest] show popular categories and best sellers
// (template#nav-search-suggestions in sections/header.liquid). Typing hides them; the predictive
// results take over.
(() => {
    const template = document.getElementById('nav-search-suggestions');
    if (!template) return;
    let productsRequest;

    const loadProducts = () => {
        productsRequest =
            productsRequest ||
            fetch(`${window.Shopify?.routes?.root || '/'}collections/all?sort_by=best-selling&section_id=nav-search-products`)
                .then((response) => (response.ok ? response.text() : ''))
                .then((html) => {
                    const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
                    return section && section.querySelector('.swiper') ? section.innerHTML : '';
                })
                .catch(() => '');
        return productsRequest;
    };

    const mountSwiper = (element) => {
        const swiperElement = element.querySelector('.swiper');
        const mount = () => {
            if (!swiperElement || swiperElement.swiper || typeof Swiper === 'undefined') return;
            new Swiper(swiperElement, {
                slidesPerView: 'auto',
                spaceBetween: 15,
                pagination: { el: element.querySelector('.swiper-pagination'), type: 'progressbar' },
            });
        };
        if (typeof window.loadSwiperBundle === 'function') {
            window.loadSwiperBundle().then(mount).catch(mount);
        } else {
            mount();
        }
    };

    const panelFor = (search) => {
        let panel = search.querySelector(':scope > .nav-suggestions');
        if (panel) return panel;
        panel = document.createElement('div');
        panel.className = 'nav-suggestions';
        panel.appendChild(template.content.cloneNode(true));
        search.appendChild(panel);
        loadProducts().then((html) => {
            const products = panel.querySelector('[data-nav-suggestions-products]');
            if (!html) {
                products.hidden = true;
                return;
            }
            products.querySelector('[data-nav-suggestions-products-list]').innerHTML = html;
            products.querySelector('[data-nav-suggestions-skeleton]')?.remove();
            mountSwiper(products);
        });
        return panel;
    };

    const update = (search) => {
        const input = search.querySelector('input[type="search"]');
        const empty = !input.value.trim();
        if (empty) panelFor(search);
        search.classList.toggle('is-suggesting', empty);
    };

    document.addEventListener('focusin', (event) => {
        const search = event.target.closest('[data-nav-suggest]');
        if (search && event.target.matches('input[type="search"]')) update(search);
    });
    ['input', 'click'].forEach((type) =>
        document.addEventListener(type, (event) => {
            const search = event.target.closest('[data-nav-suggest]');
            if (search && event.target.matches('input[type="search"]')) update(search);
        }),
    );
    document.addEventListener('reset', (event) => {
        const search = event.target.closest('[data-nav-suggest]');
        if (search) setTimeout(() => update(search));
    });
    // Close on a tap outside the search or Escape. Not on blur: on iOS a tapped link never takes focus,
    // so hiding on blur would swallow taps on the tiles.
    document.addEventListener('pointerdown', (event) => {
        document.querySelectorAll('[data-nav-suggest].is-suggesting').forEach((search) => {
            if (!search.contains(event.target)) search.classList.remove('is-suggesting');
        });
    });
    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('[data-nav-suggest].is-suggesting').forEach((search) => search.classList.remove('is-suggesting'));
    });
})();

// #7: when a search returns nothing, show "No exact matches" with related categories (menu categories
// whose names share a word with the query, then the manual list from the header settings), popular
// categories, Clear search and the help card (template#nav-search-no-results).
(() => {
    const template = document.getElementById('nav-search-no-results');
    if (!template) return;
    const manualTemplate = document.getElementById('nav-search-related');

    const words = (text) =>
        text
            .toLowerCase()
            .split(/[^a-z0-9]+/)
            .filter((word) => word.length >= 3)
            .map((word) => word.replace(/(es|s)$/, ''));

    let index;
    const categoryIndex = () => {
        if (index) return index;
        const byPath = new Map();
        document.querySelectorAll('.header-area a[href*="/collections/"], .header-bottom-area a[href*="/collections/"]').forEach((link) => {
            const title = link.textContent.trim();
            if (!title) return;
            const path = new URL(link.href, location.origin).pathname;
            const image = (link.dataset.imageUrl || '').replace(/width=\d+/, 'width=200');
            const known = byPath.get(path);
            if (!known || (!known.image && image)) byPath.set(path, { title, path, image, words: words(title) });
        });
        index = [...byPath.values()];
        return index;
    };

    const matches = (query) => {
        const queryWords = words(query);
        if (!queryWords.length) return [];
        return categoryIndex()
            .map((category) => ({
                category,
                score: queryWords.filter((q) => category.words.some((w) => w.startsWith(q) || (q.startsWith(w) && q.length - w.length <= 2))).length,
            }))
            .filter((match) => match.score > 0)
            .sort((a, b) => b.score - a.score || a.category.title.length - b.category.title.length)
            .map((match) => match.category);
    };

    const tile = (category) => {
        const item = document.createElement('li');
        item.className = 'nav-categories__item';
        const link = document.createElement('a');
        link.className = 'nav-categories__link';
        link.href = category.path;
        const title = document.createElement('span');
        title.className = 'nav-categories__title';
        title.textContent = category.title;
        link.appendChild(title);
        if (category.image) {
            const image = document.createElement('img');
            image.className = 'nav-categories__image';
            image.src = category.image;
            image.width = 67;
            image.height = 67;
            image.alt = '';
            image.loading = 'lazy';
            link.appendChild(image);
        }
        item.appendChild(link);
        return item;
    };

    const render = (search, results) => {
        const query = search.querySelector('input[type="search"]').value.trim();
        // The loading skeleton (predictive-search.js) is not an empty result
        if (!query || results.querySelector('.nav-noresults, .nav-results-skeleton, .list-item, .swiper-slide')) return;
        const panel = template.content.cloneNode(true);
        panel.querySelector('[data-nav-noresults-term]').textContent = query;

        const related = [];
        const seen = new Set();
        const add = (item, path) => {
            if (related.length < 4 && !seen.has(path)) {
                seen.add(path);
                related.push(item);
            }
        };
        matches(query).forEach((category) => add(tile(category), category.path));
        manualTemplate?.content.querySelectorAll('.nav-categories__item').forEach((item) => {
            add(item.cloneNode(true), new URL(item.querySelector('a').href, location.origin).pathname);
        });
        if (related.length) {
            panel.querySelector('[data-nav-noresults-related-list]').append(...related);
            panel.querySelector('[data-nav-noresults-related]').hidden = false;
        }
        results.appendChild(panel);
    };

    document.querySelectorAll('[data-nav-suggest]').forEach((search) => {
        const results = search.querySelector('[data-predictive-search]');
        if (!results) return;
        new MutationObserver(() => render(search, results)).observe(results, { childList: true });
    });

    document.addEventListener('click', (event) => {
        const clear = event.target.closest('[data-nav-noresults-clear]');
        if (!clear) return;
        const search = clear.closest('[data-nav-suggest]');
        search?.querySelector('button[type="reset"]')?.click();
        search?.querySelector('input[type="search"]')?.focus();
    });
})();

// Search product carousels (best sellers and results): prev/next arrows on desktop, the same black
// squares as the PDP gallery (snippets/product-grid-images.liquid).
(() => {
    const arrowSvg = (direction) =>
        `<svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect width="52" height="52" fill="black"/><path d="${
            direction === 'prev'
                ? 'M35.5 26H16.5M24.6429 34L16.5 26L24.6429 18'
                : 'M16.5 26H35.5M27.3571 34L35.5 26L27.3571 18'
        }" stroke="white" stroke-width="0.835875" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/></svg>`;

    const attach = (swiperElement, attempts = 0) => {
        const swiper = swiperElement.swiper;
        if (!swiper) {
            // the carousel is mounted after Swiper's bundle loads
            if (attempts < 30) setTimeout(() => attach(swiperElement, attempts + 1), 100);
            return;
        }
        if (swiperElement.querySelector(':scope > .nav-carousel-arrow')) return;

        const arrows = ['prev', 'next'].map((direction) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = `nav-carousel-arrow nav-carousel-arrow--${direction}`;
            button.setAttribute('aria-label', direction === 'prev' ? 'Previous products' : 'Next products');
            button.innerHTML = arrowSvg(direction);
            button.addEventListener('click', () => (direction === 'prev' ? swiper.slidePrev() : swiper.slideNext()));
            swiperElement.appendChild(button);
            return button;
        });

        const update = () => {
            // centre the arrows on the product images, which are square
            const image = swiperElement.querySelector('.swiper-slide img');
            if (image) arrows.forEach((arrow) => (arrow.style.top = `${image.offsetTop + image.offsetHeight / 2}px`));
            arrows[0].disabled = swiper.isBeginning;
            arrows[1].disabled = swiper.isEnd;
            arrows.forEach((arrow) => (arrow.hidden = swiper.isLocked || (swiper.isBeginning && swiper.isEnd)));
        };
        swiper.on('slideChange', update);
        swiper.on('resize', update);
        swiper.on('reachEnd', update);
        swiper.on('reachBeginning', update);
        swiperElement.querySelectorAll('.swiper-slide img').forEach((image) => image.addEventListener('load', update, { once: true }));
        update();
    };

    document.querySelectorAll('[data-nav-suggest]').forEach((search) => {
        new MutationObserver(() => {
            search.querySelectorAll('.search-grid.swiper').forEach((swiperElement) => attach(swiperElement));
        }).observe(search, { childList: true, subtree: true });
    });
})();

// #11: footer menus are accordions on phones (sections/footer.liquid); the toggle is inert on larger screens.
document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.footer-list-wrap .ft-toggle');
    if (!toggle) return;
    const item = toggle.closest('.ftlink-li--menu');
    const open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
});
